import { useQuery } from 'react-query';
import { getUserId } from '../../../DefaultService';
import { IPaginationParams } from '../../../types';
import { getDownloadQueueAsync, getDownloadQueueCountAsync } from '../../index';
import { IDownloadQueueFilterParams } from '../../types';

const USER_ID = getUserId();

export const DOWNLOAD_QUEUE_KEYS = {
  ALL: 'downloadQueue',
  LIST: 'list',
  COUNT: 'count',
};

// Fila "viva": mantém sincronizada com o poller do backend (30s) sem exigir refresh manual.
const REFETCH_INTERVAL_MS = 15000;

export const useGetAllDownloadQueueQuery = (
  pagination: IPaginationParams,
  filter: IDownloadQueueFilterParams,
) =>
  useQuery(
    [DOWNLOAD_QUEUE_KEYS.ALL, DOWNLOAD_QUEUE_KEYS.LIST, pagination, filter, USER_ID],
    {
      keepPreviousData: true,
      refetchInterval: REFETCH_INTERVAL_MS,
      queryFn: () => getDownloadQueueAsync(pagination, filter),
    },
  );

export const useGetDownloadQueueCountQuery = (filter: IDownloadQueueFilterParams) =>
  useQuery(
    [DOWNLOAD_QUEUE_KEYS.ALL, DOWNLOAD_QUEUE_KEYS.COUNT, filter, USER_ID],
    {
      keepPreviousData: true,
      refetchInterval: REFETCH_INTERVAL_MS,
      queryFn: () => getDownloadQueueCountAsync(filter),
    },
  );
